<div id="email-container">
  <p class="subheading-01-semi-bold">
    Estas por solicitar la emisión de una NC del comprobante FC A 1-595 a AFIP.
    ¿Deseas generar la nota de crédito?
  </p>
  <mat-checkbox
    [checked]="this.emailAgent"
    color="primary"
    id="check1"
    (change)="agentChange($event.checked)"
  >
    <p class="subheading-01-semi-bold">
      Enviar copia de la nota de crédito al agente por e-mail
    </p>
  </mat-checkbox>
  <mat-checkbox
    [checked]="this.emailUser"
    color="primary"
    id="check2"
    (change)="userChange($event.checked)"
  >
    <p class="subheading-01-semi-bold">
      Deseo recibir una copia de la nota de crédito por e-mail
    </p>
  </mat-checkbox>
</div>
